<template>
  <div>
    <div class="modal fade" id="delivery-info-modal" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-lg" @click.stop>
        <div class="modal-content">
          <div class="modal-body">
            <h4 class="m-b-lg m-t-none"><strong>発送元情報</strong></h4>
            <div class="box-info-items m-b-lg">
              <div v-for="(infoItem, index) in infoItems" :key="index" :class="['delivery-info-item m-b pd-t-10 pd-b-10',  infoItem.isDefault ? 'delivery-info-default-item' : '']">
                <div v-if="infoItem.hasData" class="delivery-content m-sm">
                  <div class="row">
                    <div class="col-md-6">
                      <div>
                        <div>{{ infoItem.data.name }}</div>
                        <div>{{ infoItem.data.postalCode }}</div>
                        <div>{{ infoItem.data.address }}</div>
                        <div>{{ infoItem.data.phoneNo }}</div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="text-right m-b">
                        <button type="button" class="btn btn-primary custom-btn-delivery check-maintenance" @click.prevent="openModalUpdateInfo(infoItem)">変更する</button>
                      </div>
                      <div class="text-right">
                        <button type="button" class="btn btn-primary custom-btn-delivery m-r check-maintenance" @click.prevent="setDefaultInfo(infoItem.seq)">この情報を使用する</button>
                        <button type="button" class="btn btn-warning custom-btn-delivery check-maintenance" @click.prevent="openModalConfirmDeleteInfo(infoItem)">削除する</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="text-center register-delivery-info m-t-md m-b-md">
                  <button type="button" class="btn btn-primary custom-btn-delivery check-maintenance" @click.prevent="openModalRegisterInfo(infoItem.seq)">登録する</button>
                </div>
              </div>
            </div>
            <div class="m-t-sm text-center">
              <button type="button" class="btn btn-basic custom-btn-delivery" data-dismiss="modal" @click.prevent="$emit('close')">閉じる</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal confirm delete delivery info -->
    <modal-confirm
      v-if="openDeleteInfoConfirmModal"
      :message="deleteInfoConfirmMessage"
      :customHide="true"
      @confirm="deleteInfo"
      @close="closeModalConfirmDeleteInfo"
    />
  </div>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import ModalConfirm from '@/components/ModalConfirm'
import DeliveryInfoSellerService from '@/services/deliveryinfosellerservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    ModalConfirm
  },
  data () {
    return {
      openDeleteInfoConfirmModal: false,
      selectedInfo: null,
      loader: null
    }
  },
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    deleteInfoConfirmMessage () {
      return 'この発送元情報を削除してもよろしいですか？'
    },
    ...mapGetters({
      deliveryInfoItems: 'getDeliveryInfoItems',
      deliveryInfoItemNumber: 'getDeliveryInfoItemNumber'
    }),
    infoItems () {
      let items = []
      for (let i = 1; i <= this.deliveryInfoItemNumber; i++) {
        items.push({
          seq: i,
          isDefault: false,
          hasData: false,
          data: null
        })
      }
      for (let index in items) {
        let item = items[index]
        let deliveryInfo = this.deliveryInfoItems.find(record => record.seq === item.seq) || {}
        if (Object.keys(deliveryInfo).length) {
          item.data = deliveryInfo
          item.isDefault = parseInt(deliveryInfo.defFlg) === 1
          item.hasData = true
        }
      }
      return items
    }
  },
  methods: {
    openModalRegisterInfo (seq) {
      this.$emit('openModalRegisterDeliveryInfo')
      store.commit('setCurrentDeliveryInfoSeq', seq)
    },
    openModalConfirmDeleteInfo (infoItem) {
      this.openDeleteInfoConfirmModal = true
      this.selectedInfo = infoItem
    },
    closeModalConfirmDeleteInfo () {
      $('#confirm-alert').modal('hide')
      this.openDeleteInfoConfirmModal = false
    },
    deleteInfo () {
      if (!this.selectedInfo) {
        return
      }
      let params = {
        seq: this.selectedInfo.seq
      }
      this.loader = this.$loading.show()
      DeliveryInfoSellerService.destroy(params)
        .then((response) => {
          store.commit('setDeliveryInfoItems', response.data)
          this.selectedInfo = null
          this.closeModalConfirmDeleteInfo()
          this.loader && this.loader.hide()
        })
        .catch((error) => {
          this.loader && this.loader.hide()
          store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
      let name = eventCode.delivery_requests.delivery_request_registration_tab.delivery_info.click_delete_button
      switch (this.type) {
        case 'Across':
          name = eventCode.warehouse_across.delivery_tab.direct_delivery.click_delete_shipping_info_btn
          break
        case 'Sc':
          name = eventCode.warehouse_sc.delivery_tab.direct_delivery.click_delete_shipping_info_btn
          break
        default:
          name = eventCode.delivery_requests.delivery_request_registration_tab.delivery_info.click_delete_button
          break
      }
      let logParams = {
        name: name,
        properties: params
      }
      EventService.postTrackLog(logParams)
    },
    setDefaultInfo (seq) {
      this.loader = this.$loading.show()
      DeliveryInfoSellerService.setDefault({ seq })
        .then((response) => {
          store.commit('setDeliveryInfoItems', response.data)
          this.$emit('close')
          this.loader && this.loader.hide()
          this.$emit('setDefaultInfoSuccess', response.data.find(item => item.defFlg === '1'))
        })
        .catch((error) => {
          this.loader && this.loader.hide()
          store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
      let name = eventCode.delivery_requests.delivery_request_registration_tab.delivery_info.click_use_button
      switch (this.type) {
        case 'Across':
          name = eventCode.warehouse_across.delivery_tab.direct_delivery.click_use_shipping_info_btn
          break
        case 'Sc':
          name = eventCode.warehouse_sc.delivery_tab.direct_delivery.click_use_shipping_info_btn
          break
        default:
          name = eventCode.delivery_requests.delivery_request_registration_tab.delivery_info.click_use_button
          break
      }
      let logParams = {
        name: name,
        properties: {
          seq: seq
        }
      }
      EventService.postTrackLog(logParams)
    },
    openModalUpdateInfo (infoItem) {
      this.$emit('openModalRegisterDeliveryInfo')
      store.commit('setSelectedDeliveryInfoItem', infoItem.data)
    }
  },
  mounted () {
    $('#delivery-info-modal').modal('show')
    $('#delivery-info-modal').on('hidden.bs.modal', (e) => {
      if (!$('#register-delivery-info-modal').length) {
        $('body').attr({
          style: 'padding-right: 0px !important; overflow: unset !important'
        })
      } else {
        $('body').attr('style', 'overflow: hidden !important')
      }
    })
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
    setTimeout(() => {
      if (!$('#register-delivery-info-modal').length) {
        $('body').attr({
          style: null
        })
      } else {
        $('body').attr('style', 'overflow: hidden !important')
      }
    }, 700)
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deliveryRequests/components/DeliveryInfoModal.vue